import { useEffect, useState, useRef } from 'react';
import { useGetImageByLinkQuery } from '../../../services/agrocraftArtisan';
import { extractAgripixPath } from '../../../utils/functions/string';
import { CircularProgress } from '@mui/material';

type TProps = {
  imagePath: string;
  onLoadingChange?: (isLoading: boolean) => void;
  onErrorChange?: (hasError: boolean) => void;
  hideLoader?: boolean;
};

export const ImageWithQuery = ({
  imagePath,
  onLoadingChange,
  onErrorChange,
  hideLoader = false,
}: TProps) => {
  const finalPath = extractAgripixPath(imagePath);

  const { data, error, isLoading } = useGetImageByLinkQuery(
    finalPath,
    {
      skip: !finalPath,
    }
  );

  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const onLoadingChangeRef = useRef(onLoadingChange);
  const onErrorChangeRef = useRef(onErrorChange);

  useEffect(() => {
    onLoadingChangeRef.current = onLoadingChange;
  }, [onLoadingChange]);

  useEffect(() => {
    onErrorChangeRef.current = onErrorChange;
  }, [onErrorChange]);

  useEffect(() => {
    if (onLoadingChangeRef.current) {
      onLoadingChangeRef.current(isLoading);
    }
  }, [isLoading]);

  useEffect(() => {
    if (onErrorChangeRef.current) {
      onErrorChangeRef.current(!!error);
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      const url = URL.createObjectURL(data);
      setBlobUrl(url);

      return () => URL.revokeObjectURL(url);
    }
  }, [data]);

  if (isLoading && !hideLoader) {
    return (
      <div className="image-loader">
        <CircularProgress
          className="image-loader-spinner"
          color="error"
          size={70}
          thickness={2.5}
        />
      </div>
    );
  }

  if (isLoading && hideLoader) {
    return <div className="image-loader" style={{ visibility: 'hidden' }} />;
  }

  if (error) {
    return (
      <p className="image-error">Error loading image</p>
    );
  }

  return blobUrl ? (
    <img src={blobUrl} alt="Fetched content" />
  ) : null;
};

